import React from "react";
import { Popover as PopoverPrimitive } from "radix-ui";

const NAME = "PopoverRoot";

export type PopoverRootProps = PopoverPrimitive.PopoverProps;

export const PopoverRoot = ({ children, ...props }: PopoverRootProps) => (
  <PopoverPrimitive.Root {...props}>{children}</PopoverPrimitive.Root>
);

PopoverRoot.displayName = NAME;
